export const BookingStatus = {
  INQUIRY: 'inquiry',
  ACCEPTED: 'accepted',
  CONFIRMED: 'booking confirmed',
  AWAITING_DETAILS: 'awaiting details',
  PENDING_PAYMENT: 'payment pending',
  FAILED_PAYMENT: 'payment failed',
  RESCHEDULE_REQUESTED: 'reschedule requested',
  RESCHEDULE_ACCEPTED: 'rescheduling accepted',
  RESCHEDULE_DECLINED: 'rescheduling declined',
  PENDING: 'pending',
  CANCELLED: 'cancelled',
  CANCELLED: 'cancelled',
  DECLINED: 'declined',
  COMPLETED: 'completed',
  DISPUTED: 'disputed',
  REVIEWED: 'reviewed',
  REFUNDED: 'refunded',
  ON_HOLD: 'on-hold',
  PAID_OUT: 'paid-out',
  PAYOUT_FAILED: 'payout-failed',
  PAYOUT_REVERSED: 'payout-reversed',
};

export const USER_TYPES = {
  CUSTOMER: 'customer',
  HOST: 'host',
};

export const CREW_SIZES = [
  { label: '1-5', multiplier: 1 },
  { label: '6-15', multiplier: 1.1 },
  { label: '16-30', multiplier: 1.2 },
  { label: '31-45', multiplier: 1.25 },
  { label: '46-60', multiplier: 1.4 },
  { label: '60+', multiplier: 1.15 },
];

export const PRICING_TABS = {
  PHOTO: 'PHOTO',
  VIDEO: 'VIDEO',
  MULTIPURPOSE: 'MULTIPURPOSE',
};

export const DURATION_TYPE = {
  HOURLY: 'hourly',
  HALF_DAY: 'halfDay',
  FULL_DAY: 'fullDay',
};

export const authOnlyTopbarPaths = ['/favorites'];

export const PrimaryListingFieldKeys = Object.freeze({
  NUMBER_BEDROOMS: 'number_bedrooms',
  NUMBER_BATHROOMS: 'number_bathrooms',
  PROPERTY_SIZE_M2: 'property_size_m2',
  MAIN_FLOOR_NUMBER: 'main_floor_number',
  TRUCK_PARKING: 'truck_parking',
  PARKING_SPOTS: 'parking_spots',
  PARKING_SPACE: 'parking_space',
  LOADING_DOCK: 'loading_dock',
  ACCESS_OPTIONS: 'access_options',
  WIFI_CONNECTIVITY: 'wifi_connectivity',
});

export const FeaturesListingFieldKeys = Object.freeze({
  AMENITIES: 'amenities',
  THEME: 'theme',
  WALL: 'wall',
  FLOOR: 'floor',
  WINDOWS: 'windows',
  CEILING: 'ceiling_height',
});

export const ProductionDetailsListingFieldKeys = Object.freeze({
  STUDIO_AND_PRODUCTION: 'studio_and_production_features',
  POWER_SUPPLY: 'power_supply',
  SAFETY_AND_SECURITY: 'safety_and_security',
});

export const fieldDescriptions = [
  {
    key: 'Amenities',
    descriptionId: 'EditListingFieldDescription.amenities',
  },
  {
    key: 'Theme',
    descriptionId: 'EditListingFieldDescription.theme',
  },
  {
    key: 'Types of Wall',
    descriptionId: 'EditListingFieldDescription.typesOfWall',
  },
  {
    key: 'Type of Floor',
    descriptionId: 'EditListingFieldDescription.typeOfFloor',
  },
  {
    key: 'Type of Windows',
    descriptionId: 'EditListingFieldDescription.typeOfWindows',
  },
  {
    key: 'Ceiling Height',
    descriptionId: 'EditListingFieldDescription.ceilingHeight',
  },
];

export const crewRules = [
  { key: 'electricity_usage', label: 'EditListingProductionForm.electricityUsageLabel' },
  { key: '“smoke_fog_machine', label: 'EditListingProductionForm.smokeFogMachine' },
  { key: 'smoking', label: 'EditListingProductionForm.smokingLabel' },
  { key: 'pets', label: 'EditListingProductionForm.petsLabel' },
  { key: 'outside_catering_food', label: 'EditListingProductionForm.outsideCateringLabel' },
  { key: 'cooking', label: 'EditListingProductionForm.cookingLabel' },
  { key: 'alcohol', label: 'EditListingProductionForm.alcoholLabel' },
  { key: 'loud_noises', label: 'EditListingProductionForm.loudNoisesLabel' },
  { key: 'adult_filming', label: 'EditListingProductionForm.adultFilmingLabel' },
];

export const TRANSITIONS = {
  REVIEW_1_BY_PROVIDER: 'transition/review-1-by-provider',
  REVIEW_2_BY_PROVIDER: 'transition/review-2-by-provider',
  REVIEW_1_BY_CUSTOMER: 'transition/review-1-by-customer',
  REVIEW_2_BY_CUSTOMER: 'transition/review-2-by-customer',
  TRANSITION_RESCHEDULE_BOOKING: 'transition/reschedule-booking',
  TRANSITION_INQUIRE: 'transition/inquire',
  REQUEST_ACCOUNT_INFO_BY_PROVIDER: 'transition/request-account-info-by-provider',
  ADD_ACCOUNT_INFO_BY_CUSTOMER: 'transition/add-account-info-by-customer',
  PAYMENT_FAILED: 'transition/payment-failed',
  CONFIRM_PAYMENT: 'transition/confirm-payment',
  OPERATOR_CONFIRM_PAYMENT: 'transition/operator-confirm-payment',
  CONFIRM_CUSTOM_OFFER_PAYMENT: 'transition/confirm-custom-offer-payment',
  OPERATOR_CONFIRM_CUSTOM_OFFER_PAYMENT: 'transition/operator-confirm-custom-offer-payment',
  COMPLETE_CUSTOM_OFFER_PAYMENT: 'transition/complete-custom-offer-payment',
  CONFIRM_CUSTOM_OFFER_PAY_LATER_PAYMENT: 'transition/confirm-custom-offer-pay-later-payment',
  RESCHEDULE_CUSTOM_OFFER: 'transition/reschedule-custom-offer',
  RESCHEDULE_CUSTOM_OFFER_PAYMENT: 'transition/reschedule-custom-offer-payment',
  RESCHEDULE_CUSTOM_OFFER_PREAUTHORIZED: 'transition/reschedule-custom-offer-preauthorized',
  RESCHEDULE_CUSTOM_OFFER_PAY_LATER_PAYMENT:
    'transition/reschedule-custom-offer-pay-later-payment',
  RESCHEDULE_CUSTOM_OFFER_ACCEPTED_PENDING_PAYMENT:
    'transition/reschedule-custom-offer-accepted-pending-payment',
  RESCHEDULE_CUSTOM_OFFER_BOOKING: 'transition/reschedule-custom-offer-booking',
  CONFIRM_PAY_LATER_PAYMENT: 'transition/confirm-pay-later-payment',
  OPERATOR_CONFIRM_PAY_LATER_PAYMENT: 'transition/operator-confirm-pay-later-payment',
  COMPLETE_AFTER_CANCEL: 'transition/complete-after-cancel',
  OPERATOR_COMPLETE_AFTER_CANCEL: 'transition/operator-complete-after-cancel',
  DECLINE: 'transition/decline',
  INITIATE_REFUND: 'transition/initiate-refund',
  EXPIRE: 'transition/expire',
  EXPIRE_PAYMENT: 'transition/expire-payment',
  ACCEPTANCE_WINDOW_PASSED: 'transition/acceptance-window-passed',
  PAY_LATER_ACCEPTANCE_WINDOW_PASSED: 'transition/pay-later-acceptance-window-passed',
  AUTO_DECLINE_BOOKING_TIME_STARTS: 'transition/auto-decline-booking-time-starts',

  OPERATOR_ACCEPTANCE_WINDOW_PASSED: 'transition/operator-acceptance-window-passed',
  OPERATOR_PAY_LATER_ACCEPTANCE_WINDOW_PASSED:
    'transition/operator-pay-later-acceptance-window-passed',
  OPERATOR_DECLINE: 'transition/operator-decline',
  OPERATOR_DECLINE_PAY_LATER: 'transition/operator-decline-pay-later',
  ACCEPT: 'transition/accept',
  ACCEPT_PAY_LATER: 'transition/accept-pay-later',
  OPERATOR_ACCEPT: 'transition/operator-accept',
  OPERATOR_ACCEPT_PAY_LATER: 'transition/operator-accept-pay-later',
  DECLINE_PAY_LATER: 'transition/decline-pay-later',
  REQUEST_PAYMENT: 'transition/request-payment',
  REQUEST_PAY_LATER_PAYMENT: 'transition/request-pay-later-payment',
  REQUEST_PAYMENT_AFTER_INQUIRY: 'transition/request-payment-after-inquiry',
  REQUEST_PAY_LATER_PAYMENT_AFTER_INQUIRY: 'transition/request-pay-later-payment-after-inquiry',
  REQUEST_CUSTOM_OFFER_PAYMENT_AFTER_INQUIRY:
    'transition/request-custom-offer-payment-after-inquiry',
  REQUEST_CUSTOM_OFFER_PAY_LATER_PAYMENT_AFTER_INQUIRY:
    'transition/request-custom-offer-pay-later-payment-after-inquiry',
  RETRY_PAYMENT_AFTER_FAILED: 'transition/retry-payment-after-failed',
  RETRY_PAY_LATER_PAYMENT_AFTER_FAILED: 'transition/retry-pay-later-payment-after-failed',
  RETRY_CUSTOM_OFFER_PAYMENT_AFTER_FAILED: 'transition/retry-custom-offer-payment-after-failed',
  RETRY_CUSTOM_OFFER_PAY_LATER_PAYMENT_AFTER_FAILED:
    'transition/retry-custom-offer-pay-later-payment-after-failed',
  AUTO_CANCEL_FROM_DISPUTED: 'transition/auto-cancel-from-disputed',
  CANCEL_FROM_DISPUTED: 'transition/cancel-from-disputed',
  MARK_RECEIVED_FROM_DISPUTED: 'transition/mark-received-from-disputed',
  PAYOUT_COMPLETE: 'transition/payout-complete',
  OPERATOR_PAYOUT_COMPLETE: 'transition/operator-payout-complete',
  CANCEL_BY_CUSTOMER: 'transition/cancel-by-customer',
  CANCEL_BY_PROVIDER: 'transition/cancel-by-provider',
  CANCEL_BOOKING_REQUEST_PAYMENT: 'transition/cancel-booking-request-payment',
  CANCEL_BOOKING_REQUEST: 'transition/cancel-booking-request',
  CANCEL_PAY_LATER_BOOKING_REQUEST: 'transition/cancel-pay-later-booking-request',
  COMPLETE: 'transition/complete',
  OPERATOR_COMPLETE: 'transition/operator-complete',
  DISPUTE: 'transition/dispute',
  CANCEL: 'transition/cancel',
  OPERATOR_DISPUTE: 'transition/operator-dispute',
  RESCHEDULE_BOOKING: 'transition/reschedule-booking',
  ACCEPT_RESCHEDULE_BOOKING: 'transition/accept-reschedule-booking',
  DECLINE_RESCHEDULE_BOOKING: 'transition/decline-reschedule-booking',
  PAYMNENT_WINDOW_PASSED: 'transition/payment-window-passed',
  OPERATOR_PAYMNENT_WINDOW_PASSED: 'transition/operator-payment-window-passed',
};

export const FILTERED_TRANSITIONS_SET = new Set([
  TRANSITIONS.CANCEL_FROM_DISPUTED,
  TRANSITIONS.AUTO_CANCEL_FROM_DISPUTED,
  TRANSITIONS.CANCEL_BY_CUSTOMER,
  TRANSITIONS.CANCEL_BY_PROVIDER,
  TRANSITIONS.CANCEL_BOOKING_REQUEST_PAYMENT,
  TRANSITIONS.CANCEL_BOOKING_REQUEST,
  TRANSITIONS.CANCEL_PAY_LATER_BOOKING_REQUEST,
  TRANSITIONS.CANCEL,
  TRANSITIONS.DECLINE,
  TRANSITIONS.DECLINE_PAY_LATER,
  TRANSITIONS.OPERATOR_DECLINE,
  TRANSITIONS.OPERATOR_DECLINE_PAY_LATER,
  TRANSITIONS.ACCEPTANCE_WINDOW_PASSED,
  TRANSITIONS.PAY_LATER_ACCEPTANCE_WINDOW_PASSED,
  TRANSITIONS.OPERATOR_ACCEPTANCE_WINDOW_PASSED,
  TRANSITIONS.OPERATOR_PAY_LATER_ACCEPTANCE_WINDOW_PASSED,
  TRANSITIONS.AUTO_DECLINE_BOOKING_TIME_STARTS,
  TRANSITIONS.EXPIRE,
  TRANSITIONS.EXPIRE_PAYMENT,
  TRANSITIONS.PAYMNENT_WINDOW_PASSED,
  TRANSITIONS.OPERATOR_PAYMNENT_WINDOW_PASSED,
  TRANSITIONS.REQUEST_ACCOUNT_INFO_BY_PROVIDER,
  TRANSITIONS.ADD_ACCOUNT_INFO_BY_CUSTOMER,
  TRANSITIONS.INITIATE_REFUND,
  TRANSITIONS.COMPLETE_AFTER_CANCEL,
  TRANSITIONS.OPERATOR_COMPLETE_AFTER_CANCEL,
  TRANSITIONS.DISPUTE,
  TRANSITIONS.OPERATOR_DISPUTE,
]);

export const PAYMENT_METHODS = {
  CARD: 'card-flow',
  PROMPTPAY: 'promptpay',
  MOBILE_BANKING: 'mobile_banking',
};

export const CHARGE_STATUS = {
  AUTHORIZED: 'authorized',
  CANCELED: 'cancel',
  PENDING: 'pending',
  FAILED: 'failed',
  SUCCESSFUL: 'successful',
  EXPIRED: 'expired',
  REFUNDED: 'fullRefunded',
  REVERSED: 'reversed',
  NO_REFUND: 'noRefund',
  HALF_REFUND: 'halfRefund',
};

export const omiseSupportedBankOptions = [
  { value: 'baac', label: 'Bank for Agriculture and Agricultural Cooperatives' },
  { value: 'bay', label: 'Bank of Ayudhya (Krungsri)' },
  { value: 'bbl', label: 'Bangkok Bank (BBL)' },
  { value: 'bnp', label: 'BNP Paribas' },
  { value: 'boa', label: 'Bank of America' },
  { value: 'cacib', label: 'Crédit Agricole' },
  { value: 'cimb', label: 'CIMB Thai Bank' },
  { value: 'citi', label: 'Citibank' },
  { value: 'db', label: 'Deutsche Bank' },
  { value: 'ghb', label: 'Government Housing Bank' },
  { value: 'gsb', label: 'Government Savings Bank' },
  { value: 'hsbc', label: 'Hongkong and Shanghai Banking Corporation' },
  { value: 'ibank', label: 'Islamic Bank of Thailand' },
  { value: 'icbc', label: 'Industrial and Commercial Bank of China (Thai)' },
  { value: 'jpm', label: 'J.P. Morgan' },
  { value: 'kbank', label: 'Kasikornbank (KBANK)' },
  { value: 'kk', label: 'Kiatnakin Bank' },
  { value: 'ktb', label: 'Krungthai Bank (KTB)' },
  { value: 'lhb', label: 'Land and Houses Bank' },
  { value: 'mb', label: 'Mizuho Bank' },
  { value: 'mega', label: 'Mega International Commercial Bank' },
  { value: 'mufg', label: 'Bank of Tokyo-Mitsubishi UFJ (MUFG)' },
  { value: 'rbs', label: 'Royal Bank of Scotland' },
  { value: 'sc', label: 'Standard Chartered (Thai)' },
  { value: 'scb', label: 'Siam Commercial Bank (SCB)' },
  { value: 'smbc', label: 'Sumitomo Mitsui Banking Corporation (SMBC)' },
  { value: 'tcrb', label: 'Thai Credit Retail Bank' },
  { value: 'tisco', label: 'Tisco Bank' },
  { value: 'ttb', label: 'TMBThanachart Bank (TTB)' },
  { value: 'uob', label: 'United Overseas Bank (Thai) (UOB)' },
];

export const MOBILE_BANKING_OPTIONS = [
  {
    key: 'mobile_banking_scb',
    labelId: 'SCB Easy',
    icon: 'SCBEast',
  },
  {
    key: 'mobile_banking_bay',
    labelId: 'Krungsri KMA',
    icon: 'krungsriKMA',
  },
  // {
  //   key: 'mobile_banking_ktb',
  //   labelId: 'KTB Next',
  //   icon: 'krungsriKMA',
  // },
  {
    key: 'mobile_banking_bbl',
    labelId: 'Bangkok Bank',
    icon: 'bangkokBank',
  },
  // possible additions — only if you verify that these banks support the mobile-banking flow:
  {
    key: 'mobile_banking_kbank',
    labelId: 'KBank',
    icon: 'kbank',
  },
  // {
  //   key: 'mobile_banking_gsb',
  //   labelId: 'Government Savings Bank',
  // },
];

export const CheckoutSteps = Object.freeze({
  PROJECT_INFO: 'projectInfo',
  PAYMENT: 'payment',
});

export const checkoutStepsTabs = [
  {
    step: CheckoutSteps.PROJECT_INFO,
    id: 'CheckoutSteps.projectInfo',
    defaultMessage: 'Project Details',
  },
  {
    step: CheckoutSteps.PAYMENT,
    id: 'CheckoutSteps.payment',
    defaultMessage: 'Payment',
  },
];

export const ACTIVITY_OPTIONS = [
  {
    key: 'photo',
    label: 'Photo shoot',
    labelTh: 'ถ่ายภาพ',
  },
  {
    key: 'video',
    label: 'Video shoot',
    labelTh: 'ถ่ายวิดีโอ',
  },
  {
    key: 'event',
    label: 'Event',
    labelTh: 'อีเวนต์',
  },
];

export const NEXT_STATE_ICON_MAP = {
  accepted: 'accepted',
  'accepted-pending-payment': 'request',
  delivered: 'accepted',
  'pending-payment': 'request',
  'booking-rescheduled': 'reschedule',
  cancelled: 'cancelled',
  preauthorized: 'request',
  declined: 'cancelled',
  completed: 'accepted',
  disputed: 'dispute',
  'reviewed-by-customer': 'reviewed',
  'reviewed-by-provider': 'reviewed',
  reviewed: 'reviewed',
};

export const DEFAULT_IMAGE_VARIANT = 'default';

export const NON_TRANSLATED_PATHS = ['/guides', '/events', '/event'];

export const transactionStatusIntlMap = {
  inquiry: 'BookingStatus.inquiry',
  accepted: 'BookingStatus.accepted',
  'booking confirmed': 'BookingStatus.bookingConfirmed',
  'awaiting details': 'BookingStatus.awaitingDetails',
  'reschedule requested': 'BookingStatus.rescheduleRequested',
  'rescheduling accepted': 'BookingStatus.reschedulingAccepted',
  'rescheduling declined': 'BookingStatus.reschedulingDeclined',
  pending: 'BookingStatus.pending',
  'payment pending': 'BookingStatus.pendingPayment',
  'payment failed': 'BookingStatus.failedPayment',
  cancelled: 'BookingStatus.cancelled',
  declined: 'BookingStatus.declined',
  completed: 'BookingStatus.completed',
  disputed: 'BookingStatus.disputed',
  reviewed: 'BookingStatus.reviewed',
  refunded: 'BookingStatus.refunded',
  'on-hold': 'BookingStatus.onHold',
  'paid-out': 'BookingStatus.paidOut',
  'payout-failed': 'BookingStatus.payoutFailed',
  'payout-reversed': 'BookingStatus.payoutReversed',
};

export const USER_TYPE_INTL = {
  host: 'UserType.host',
  creative: 'UserType.creative',
};

export const THAI_PAGE_IDS = {
  HOST_AGREEMENT_ID: 'host-agreement-thai',
  LANDINGPAGE_ID: 'landing-page-thai',
};

export const DEPOSIT_CHECK_KEY = 'omise_agree_deposit';
export const DEPOSIT_INSTRUCTIONS_KEY = 'omise_deposit_instructions';
